import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

import { ATOMS } from "../../recoil/atom";
import { IGuiVersion } from "../../types/versions";
import { createSnackBarContent } from "../global/useSnackBar";
import { fireDatabase } from "../../config/firebase";
import { needRequestCollections } from "../../constants/access";
import { sortByCreationDate } from "../../utils/versions";
import useNeedRequestVisibilityHelper from "../data/useNeedRequestVisibilityHelper";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

const collectionRequired = [needRequestCollections.VERSIONS];

const useGuiVersionsList = () => {
  const { t } = useTranslation(["snackbar"]);

  const popSnackbar = useSetAtom(ATOMS.SNACKBAR);

  const setGuiVersionsList = useSetAtom(ATOMS.GUI_VERSIONS);

  const [unSubscribe, setUnSubscribe] = useState<(() => void) | null>(null);

  const canLoadData = useNeedRequestVisibilityHelper(() => {
    unSubscribe && unSubscribe();
  }, collectionRequired);

  // Versions types list
  useEffect(() => {
    if (canLoadData) {
      const unsub = onSnapshot(
        collection(fireDatabase, "versions", "details", "gui_versions"),
        (snap) => {
          const dataGuiVersions: IGuiVersion[] = [];
          snap.docs.forEach((doc) => {
            const data = doc.data();
            if (data) {
              dataGuiVersions.push(data as IGuiVersion);
            }
          });
          setGuiVersionsList(dataGuiVersions.sort(sortByCreationDate("desc")));
        },
        (err) => {
          console.error(err);
          popSnackbar(
            createSnackBarContent({
              content: t("snackbar:request_gui_versions_error"),
              severity: "error",
            }),
          );
          setGuiVersionsList([]);
        },
      );

      setUnSubscribe(() => unsub);
      return () => unsub();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canLoadData]);

  return null;
};

export default useGuiVersionsList;
